import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationInterfacesByTypeMap,
} from '@toolify/server/src/services/NotificationService/types/INotificationInterfacesByTypeMap'
import {
  INotificationPayloadMapperStrategy,
} from '@toolify/client/src/modules/api/notificationPayloadMappers/types/INotificationPayloadMapperStrategy'

export function createIdentityNotificationPayloadMapperStrategy<T extends NotificationType>(
): INotificationPayloadMapperStrategy<T> {
  return {
    mapPayload(payload) {
      return payload as INotificationInterfacesByTypeMap[T]['payload']
    },
  }
}
